// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2G-Oy","productName":"Table_productName__3BbSi"};